import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import figma from "../../assets/Images/figma.png";
import lowprot1 from "../../assets/Images/lowfidprot.JPG";
import lowprot2 from "../../assets/Images/lowfidprot1.JPG";

import Slideshow from "../../assets/Slideshow/Slideshow"; // 

import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";


const Lo4Conc = () => {
    const navigate = useNavigate();
    const images = [figma, lowprot1, lowprot2];



    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo4-headings">
                <h1>Conclusion</h1>
                <p>Summarizing what I have learned</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
                        </div>
                        
            <div className="content-lo4">
                <div className="content-lo4-conclusion">
                    <div className="content-lo4-conclusion-text">
                        <h1>Group Logo and Brand Products</h1>
                        <p>
                            Our group logo and studio branding were created through a complete creative process that included important learning goals such as concept research,
                            design iteration, and interactive media creation. What started as a simple idea an octopus holding a light grew into a symbol that represented our
                            studio's basic values which are adaptation, flexibility.

                            
                        </p>

                        <p>
                            I played a key role in digitalizing and developing early logo concepts using Adobe Illustrator, exploring how our visual identity could be extended
                            to real-world items like hoodies, mugs, and bags. Feedback from peers and instructors helped shape the design into something more expressive and dynamic.
                        </p>

                        <p>
                            Although we ultimately selected a Sem's version as the final logo, the creative process from concept to iteration helped solidify our brand and taught me
                            the value of collaboration, visual storytelling, and continuous refinement.
                        </p>
                        
                    </div>

                    <div className="content-lo4-conclusion-text2">
                        <h1>Posters and 3D Poster with Arduino</h1>
                        <p>
                            The 3D Poster project was a creative experiment that used design, humor, and technology to turn a standard poster into an entertaining, interactive experience.
                            Starting with a common campaign theme cat memes we created numerous poster concepts,eventually expanded the idea by using Arduino.
                        </p>
                        <p>
                            With motion detection and audio playback, our poster became more than just a flat display; it was interactive. This fun use of technology, along with great
                            visual design, complemented the campaign's tone and effectively attracted audience attention.
                        </p>

                        <p>
                            The project not only fulfilled the learning outcomes of designing and developing an interactive product but also highlighted the importance of iteration.
                            From combining group poster drafts to refining the design based on peer and teacher feedback. In the end,
                            the 3D Arduino poster stood out as a proof of concept that showed how creative media can engage people in surprising and memorable ways.
                        </p>
                        
                    </div>

                    {/* <div className="content-lo4-conclusion-slideshow">
                        <Slideshow images={images} />

                    </div> */}

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo4Conc;